module.exports = __webpack_public_path__ + "img/BridgekeepersRobes.4c0634c1.gif";